import {useEffect, useRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../selectors/pages/lootbox/state/animate';
import {openLoot} from '../../../../reducers/lootbox/actions';
import Diamond from '../diamond';
import BlueButton from '../../../components/blue-button';

export default () => {
    const {box} = useSelector(Selector),
          line = useRef();

    const animate = (animateTo = 79) => {
        // Get center of line
        const line_center = document.querySelector('.line-fix').offsetWidth / 2,
              item_width = document.querySelector('.line .item').offsetWidth,
              margin_width = 5;

        let item_index = animateTo -1,
            left = (item_width * item_index) + (margin_width * item_index) - line_center + (item_width / 2);

        if(line.current) {
            // line.current.style.transition = `all 15s cubic-bezier(0.15, 1.00, 1, 0.99)`;
            line.current.style.transition = `all 8s ease`;
            line.current.style.transform = `translate3d(-${left}px, 0, 0)`;
        }
    }

    useEffect(() => {
        if(box.state === "animate")
            animate();
    }, [box.state]);

    return (
        <>
            <div className={`items-line`}>
                <div className="line-fix">
                    <div className="line" id="line-animation" ref={line}>
                        {box.show.map((item_key, key) => {
                            const item = box.items[item_key];

                            return (
                                <div className={`item ${item.rarity}`} key={key}>
                                    <div className="rare"></div>
                                    <div className="image">
                                        <div className="blur"></div>
                                        <img src={`${window.location.origin}/source/system/lootbox/drops/${item.type}_${item.rarity}.png`} alt="" />
                                    </div>
                                    <div className="item_info">
                                        <div className="name">{item.name}</div>
                                        <div className="value">{item.value}</div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className="selector-block">
                    <div className="selector"></div>
                </div>
            </div>
        </>
    )
}